<template>
    <section class="app-main">
     
        <div class="top-bar">
            <el-input placeholder="输入商品名称查询" v-model="name" @change="search" prefix-icon="el-icon-search" style="width:260px;margin-right: 15px" clearable></el-input>
            <el-button  @click="handleDel()" type="danger" plain>批量删除</el-button>
        </div>

        <el-card>
            <el-table ref="multipleTable" :data="tableData" height="650" style="width: 100%;" @selection-change="handleSelect">
                <el-table-column type="selection" width="60" align="center"> </el-table-column>
                <el-table-column prop="user_info.nickname" label="用户" width="100"  align="center"></el-table-column>
                <el-table-column prop="goods_info.name" label="商品名称"  min-width="160"  align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  label="评论详情" min-width="300">
                    <template slot-scope="scope">
                        <div class="stars">
                            <p>商品评价：{{scope.row.s_comment}} <el-rate v-model="scope.row.s_comment" :colors="colors"  disabled class="icon-star"></el-rate></p>
                            <p>物流运输：{{scope.row.w_comment}} <el-rate v-model="scope.row.w_comment" :colors="colors"  disabled class="icon-star"></el-rate></p>
                            <p>服务评分：{{scope.row.f_comment}} <el-rate v-model="scope.row.f_comment" :colors="colors"  disabled class="icon-star"></el-rate></p>
                        </div>
                        <p>评论：{{scope.row.content}}</p>
                        <m-video v-if="scope.row.video_url" :video.sync="scope.row.video_url"  :width="70" :height="70" file-name="goodsVideo" ></m-video>
                        <div v-if="scope.row.pic_id" style="display: inline-block;">
                            <m-img v-for="(it,index) in scope.row.pic_list" :key="index" :src="it"  />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="评价时间"  width="160"  align="center"></el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <div class="table-btns">
                            <el-button  @click="handleDel(scope.row)" type="danger" plain size="mini" style="margin:5px 0 0 0">删除评论</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  background layout="prev, pager, next, jumper" :total="total" :page-size="size" @current-change="loadData" style="padding:15px 15px 15px 0"></el-pagination>
        </el-card>

        


    </section>
</template>
<script>
import { comment_list, comment_del } from '@/api/goods.js'
import MImg   from './../../../components/Image'
import MVideo from '@/components/video.vue'
import { parseTime }  from '@/untils/index.js'

export default {
    components: { MImg, MVideo },
    data() {
        return {
            name:'',
            tableData:[],
            total: 0,
            page: 1,
            size: 10,
            colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
            ids:[], 
            input:'',
        }
    },
    methods:{
       search(){
            this.page = 1
            this.getData()
        },
        getData(){
            let params = {
                flag: 3,
                page: this.page,
            }
            if(this.name != '') {
               params.name = this.name
            }
            comment_list(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.tableData.forEach(item => {
                        item.created_at = parseTime(item.created_at)
                    })
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                    this.total = 0
                }
            })
        },
        loadData(page) {
            this.page = page
            this.getData()
        },
        handleSelect(rows) {
            this.ids = []
            rows.forEach(item => {
                this.ids.push(item.id)
            })
        },
        // 删除
        handleDel(row){
            let id = ''
            if(row) {
                id = row.id
            } else {
                if(this.ids.length == 0){
                    this.$message.error("至少要选中一条评论来进行删除哦...")
                    return false
                }
                id = this.ids.join(',')
            }
            comment_del(id).then(res => {
                if(res) {
                    this.$message({type:'success',message:'删除成功'})
                    this.getData()
                }
            })
        }
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },

        
}
</script>
<style lang="less" scoped>
section {
  .stars {
        // display: flex;
        // margin-bottom: 15px;
        &>p {
            display: flex;
            align-items: center;
            margin-right: 30px;
        }
        &>p:last-child {
            margin: 0;
        }
        .icon-star {
            margin-left: 10px;
            &>i {
                font-size: 20px;
                color: #FF9800;
                vertical-align: text-top;
            }
        }
    }
}
</style>
